

















































import { Component, Vue } from 'vue-property-decorator';
import {dateFormat, MSG_CDF, trMsg, MSG_BIP} from "@/modules/budget/bip/bip-types";

@Component({
    name: 'c-sign-status-modal'
})
export default class CBudgetSignStatusModal extends Vue {
    private MSG_CDF = MSG_CDF;
    private MSG_BIP = MSG_BIP;

    private showModal = false;
    private groupLst: any[] = [];

    private mapSignUserLst(signUserLst: any[]) {
        return signUserLst.map(row => {
            if (!row.log || row.log.length === 0) {
                return {
                    deleted: true,
                    name: row.name,
                    sign_name: row.sign_name,
                    date: ''
                };
            }

            const sign = row.log?.find((item: any) => !item.deleted);
            const hasValidSign = !!sign;

            let formattedDate = '';
            if (hasValidSign) {
                // Пытаемся получить дату из sign_date или create_date
                const dateValue = sign.sign_date || sign.create_date;

                if (dateValue) {
                    try {
                        const dateObj = new Date(dateValue);
                        if (!isNaN(dateObj.getTime())) {
                            formattedDate = dateFormat(this, dateObj);
                        }
                    } catch (e) {
                        formattedDate = '';
                    }
                }
            }

            return {
                deleted: !hasValidSign,
                name: row.name,
                sign_name: row.sign_name,
                date: formattedDate
            };
        });
    }


    private showEvent(groups: any[]) {
        this.groupLst = groups.map(g => {
            const users = this.mapSignUserLst(g.signUserLst);

            return {
                title: g.title,
                status: g.status ?? this.calcGroupStatus(users),
                users
            };
        });

        this.showModal = true;
    }

    private calcGroupStatus(users: any[]): 0 | 1 | 2 {
        const signedCount = users.filter(u => !u.deleted).length;
        if (users.length > 0 && signedCount === users.length) {
            return 1;
        }
        if (signedCount > 0) {
            return 2;
        }
        return 0;
    }

    private groupStatusMsgKey(status: 0 | 1 | 2) {
        if (status === 1) {
            return 'signed';
        }
        if (status === 2) {
            return 'part_signed';
        }
        return 'not_signed';
    }

    private trMsg(field: string) {
        return trMsg(this, field)
    }
}
